import React, { useEffect, useState } from 'react';
import { MENU_PAY_ON_DELIVERY, MENU_PREPAID } from '../../../Utils/Constants/Checkout';
import { useTranslation } from 'react-i18next';
import { TbMoodConfuzed } from 'react-icons/tb';

interface MenuPaymentMethodsProps {
    current: number | null;
    onClick: CallableFunction,
    loading: boolean;
    hasPrepaid: boolean;
    hasPayOnDelivery: boolean;
}
const MenuPaymentMethods = ({ current, loading, onClick, hasPrepaid=true, hasPayOnDelivery=true }: MenuPaymentMethodsProps) => {

    const [ noMethodsFound, setNoMethodsFound ] = useState<boolean>(false);
    useEffect(() => {
        setNoMethodsFound(!hasPrepaid && !hasPayOnDelivery);
    }, [hasPrepaid, hasPayOnDelivery]);

    const { t } = useTranslation();

    const list = [
        {label: t('checkout.menu_methods.prepaid_label'), name: MENU_PREPAID, visible: hasPrepaid },
        {label: t('checkout.menu_methods.pay_on_delivery_label'), name: MENU_PAY_ON_DELIVERY, visible: hasPayOnDelivery }
    ]

    return (
        <section className={`flex gap-2 w-full ${!loading && !noMethodsFound && 'border-b-2 border-gray-100/50'}`}>
            {list
                .filter((method: any) => method.visible)
                .map((item: any, index: number) =>
                    <div key={index} onClick={() => onClick(item.name)} className={`flex flex-col w-full gap-0.5 transition-all ease-in-out cursor-pointer -mb-1 ${current === item.name ? 'pointer-events-none text-custom-primary' : ''}`}>
                        {loading
                            ? <div className='h-8 flex items-end'><div className="flex h-4 min-w-24 w-full bg-gray-200 rounded-full animate-pulse"></div></div>
                            :
                                <>
                                    <span className="flex items-end justify-center font-bold text-nowrap px-3">{ item.label }</span>
                                    <div className='h-1.5 rounded-full w-full bg-gray-200'>
                                        <div className={`h-full rounded-full m-auto transition-all duration-400 delay-200 ease-in-out ${!loading && current === item.name ? 'bg-custom-primary w-full' : 'bg-transparent w-0'}`}></div>
                                    </div>
                                </>
                        }
                    </div>
            )}

            {!loading && noMethodsFound &&
                <div className='w-full flex items-center text-sm justify-center gap-1 text-gray-500'>
                    <TbMoodConfuzed />
                    {t('checkout.menu_methods.no_methods_found')}
                </div>
            }
        </section>
    )
};

export default MenuPaymentMethods;
